import axios from 'axios';
import React, { useEffect, useState } from 'react'
import SecurityHeaders from '../../context/SecurityHeaders';
import { AccountCircle } from '@material-ui/icons';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
const BountyUpdate = () => {
  const dispatch = useDispatch()
  const params = useParams();
  const [program,setProgram] = useState()
  const [image, setImage] = useState(null);
  const [bountyTitle, setBountyTitle] = useState();
  const [bountyDescription, setBountyDescription] = useState('');

  const [company, setCompany] = useState('');
  const [payout, setPayout] = useState('');
  const [category, setCategory] = useState('');
  const [link, setLink] = useState('');

  const [startDate, setStartDate] = useState('');
  const [status, setStatus] = useState('');
  const [techStack, setTechStack] = useState('');
  const [deadline, setDeadline] = useState('');
  const [rating, setRating] = useState('');
  const getBounty =  async () => {
    try {
      const data = new FormData();
      data.append('id', params.id);
      const response = await axios.post('https://skillsuprise.com/get-bounty-details.php',data,SecurityHeaders);
    if(response.data.status === 'success') {
     const program = response.data.data
     console.log(program);
     setBountyDescription(program.bounty_description)
     setBountyTitle(program.bounty_title)
     setCompany(program.company_name)
     setPayout(program.payout)
     setCategory(program.category)
     setLink(program.link)
 
     setStartDate(program.start_date)
     setStatus(program.status)
     setTechStack(program.tech_stack)
     setDeadline(program.deadline)
     setRating(program.rating)
     
    }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getBounty();
  }, []);
  const [update, setUpdate] = useState(false);
  
  const handleClose = () => setUpdate(false);
  const handleShow = () => setUpdate(true);
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
    }
  };
  const [open, setOpen] = useState({
    open: false,
    message: '',
    type: ''

  });


  const updateBounty = async (e) => {
    e.preventDefault();
  

    try {
      dispatch({type:'LOADING'})
      const data = new FormData();
      if (image) {
        data.append('image', image);
      }
  
      data.append('bounty_title', bountyTitle);
      data.append('bounty_description', bountyDescription);
      data.append("company", company);
      data.append("payout", payout);
      data.append("category", category);
      data.append("link", link);
     
      data.append("start_date", startDate);
      data.append("status", status);
      data.append("tech_stack", techStack);
      data.append("deadline", deadline);
      data.append("rating", rating);
      data.append("bounty_id", params.id)
      const res = await axios.post("https://skillsuprise.com/update-bounties.php", data, SecurityHeaders);
      if (res.data.status === 'success') {
       
        dispatch({type:'DONE_LOADING'})

        handleClose();
        setOpen({ open: true, message: res.data.message, type: 'success' })

      } else {
        dispatch({type:'ERROR',payload:res.data.message})

        setOpen({ open: true, message: res.data.message, type: 'error' })
      }
    } catch (error) {
      dispatch({type:'ERROR',payload:error.message})

      setOpen({ open: true, message: error, type: 'error' })
    }
  };
  const handleClose2 = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(open => ({ ...open, open: false }));
  };
  return (
    <>
     <div className='col-12'>
     <Snackbar open={open.open} onClose={handleClose2} autoHideDuration={4000} >
        <Alert

          severity={open.type === 'success' ? 'success' : 'error'}
          onClose={() => { }}
          variant="filled"
          className='col-12'

        >
          {open.message}
        </Alert>
      </Snackbar>
     </div>
  <div>
  <h2 className='mb-3 text-center my-3 text-primary'>Add Bounty</h2>
      <div className="d-flex justify-content-center">
        <div className="card col-11 col-8 col-sm-12 col-md-8 p-4 shadow rounded-3">
         
          <form onSubmit={updateBounty} >
            <div className="mb-3">
              <label htmlFor="profilePic" className="form-label">Image</label>
              <div>
                <div
                  style={{
                    height: 90,
                    width: 90,
                    borderRadius: '50%',
                    overflow: 'hidden',
                    cursor: 'pointer',
                    display: 'inline-block',
                    backgroundColor: '#f0f0f0',
                    backgroundImage: image ? `url(${URL.createObjectURL(image)})` : 'none',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                  onClick={() => {
                    const input = document.createElement('input');
                    input.type = 'file';
                    input.accept = 'image/*';
                    input.onchange = handleFileChange;
                    input.click();
                  }}
                >
                  {!image && (
                    <AccountCircle style={{ height: '100%', width: '100%', color: '#ccc' }} />
                  )}
                </div>
              </div>
            </div>

            <div className="mb-3">
              <label htmlFor="designation" className="form-label">Name</label>
              <input type="text" value={bountyTitle} className="form-control" onChange={(e) => setBountyTitle(e.target.value)} required />
            </div>
            <div className="mb-3">
              <label htmlFor="category" className="form-label">Description</label>
              <input type="text" value={bountyDescription} className="form-control" onChange={(e) => setBountyDescription(e.target.value)} required />
            </div>

            <div className="mb-3">
              <label htmlFor="company" className="form-label">Company</label>
              <input type="text" value={company} className="form-control" onChange={(e) => setCompany(e.target.value)} required />
            </div>

            <div className="mb-3">
              <label htmlFor="payout" className="form-label">Payout</label>
              <input type="number" value={payout} className="form-control" onChange={(e) => setPayout(e.target.value)} required />
            </div>

            <div className="mb-3">
              <label htmlFor="category" className="form-label">Category</label>
              <input type="text" value={category} className="form-control" onChange={(e) => setCategory(e.target.value)} required />
            </div>

            <div className="mb-3">
              <label htmlFor="link" className="form-label">Link</label>
              <input type="text" value={link} className="form-control" onChange={(e) => setLink(e.target.value)} required />
            </div>



            <div className="mb-3">
              <label htmlFor="start_date" className="form-label">Start Date</label>
              <input type="date" value={startDate} className="form-control" onChange={(e) => setStartDate(e.target.value)} required />
            </div>

            <div className="mb-3">
              <label htmlFor="status" className="form-label">Status</label>
              <select className="form-control" value={status} onChange={(e) => setStatus(e.target.value)} required>
                <option value="">Select Status</option>
                <option value="open">Open</option>
                <option value="closed">Closed</option>
                <option value="in-progress">In Progress</option>
              </select>
            </div>
            <div className="mb-3">
              <label htmlFor="tech_stack" className="form-label">Tech Stack</label>
              <input type="text" value={techStack} className="form-control" onChange={(e) => setTechStack(e.target.value)} required />
            </div>

            <div className="mb-3">
              <label htmlFor="deadline" className="form-label">Deadline</label>
              <input type="date" value={deadline} className="form-control" onChange={(e) => setDeadline(e.target.value)} required />
            </div>

            <div className="mb-3">
              <label htmlFor="rating" className="form-label">Rating</label>
              <input type="number" value={rating} className="form-control" min="1" max="5" onChange={(e) => setRating(e.target.value)} required />
            </div>


            <button type="submit" className="btn btn-primary">Add Bounty</button>
            {/* <Link to="/team-members-all" className="btn btn-secondary ms-2">Cancel</Link> */}
          </form>
        </div>
      </div>
  </div>

    </>
  )
}

export default BountyUpdate
